// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__qUvDv","resendInfoText":"OnGoingPaymentBox_resendInfoText__2iJmQ"};